import script from "./bottom.vue?vue&type=script&lang=ts&setup=true"
export * from "./bottom.vue?vue&type=script&lang=ts&setup=true"

import "./bottom.vue?vue&type=style&index=0&id=156c16c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-156c16c4"]])

export default __exports__